import React from "react";

import Corpo from "../components/Corpo";

export default function TabRegras(props) {
  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div
            className="view-termo pane pane-game"
            style={{ maxHeight: "100%", overflow: "auto", marginTop: "38px" }}
          >
            <div
              className="scroll"
              style={{
                transform: "translate3d(0px, 0px, 0px) scale(1)",
              }}
            >
            <div className="text-container">
              <h2>REGRAS DO CONHECIGAME</h2>
              <p>
                O ConheciGame é um aplicativo gratuito onde os colaboradores do Sebrae podem complementar seus estudos e testar seus conhecimentos em formato de Quiz. O game apresenta dois modos, sendo que um deles deve ser selecionado pelo usuário no início da jogada:
              </p>
              <ul className="lists-ul">
                <li>
                  <strong>Modo single player</strong> — onde o participante joga sozinho.
                </li>
                <li>
                  <strong>Modo Multiplayer</strong> — onde o participante poderá jogar com outros competidores que estejam on-line no momento.
                </li>
              </ul>
              <h3>Iniciando o Game</h3>
              <p>
                Para iniciar, o jogador deverá fazer login com os mesmos dados de acesso ao AMEI.
              </p>
              <p>
              Ao fazer login no aplicativo, o jogador terá acesso ao Termo de Aceite. Ao confirmar o aceite, o jogo terá início. O aceite é dado somente no primeiro acesso do usuário ao game.
              </p>
              <p>
                O jogador deverá escolher o conteúdo sobre o qual deseja complementar seus estudos e, em seguida, selecionar o modo Single Player ou Multiplayer.
              </p>
              <h3>Jogando no modo Single Player</h3>
              <ol className="lists-ol">
                <li>
                  Ao optar por jogar o modo single player, o jogador deverá selecionar na tela “Não perturbe” se deseja ou não receber convite para jogar com outros jogadores no modo multiplayer enquanto estiver estudando/jogando. Se clicar em “Sim”, ele ficará disponível para partidas ao encerrar sua lista de perguntas.
                </li>
                <li>
                  Ao selecionar o tema, será apresentado um painel com 30 perguntas.
                </li>
                <li>
                  A cada sequência de respostas corretas a pontuação do jogador é multiplicada conforme abaixo:
                  <ul className="lists-ul">
                    <li>
                      2 respostas sequenciais respondidas corretamente: o valor da pergunta é multiplicado por dois;
                    </li>
                    <li>
                      3 ou mais respostas sequenciais respondidas corretamente: o valor da pergunta é multiplicado por cinco.
                    </li>
                  </ul>
                </li>
                <li>
                  A cada 10 perguntas corretas, o jogador recebe uma bonificação de 10 pontos.
                </li>
                <li>
                  O game apresenta 30 perguntas por tema selecionado. Quando o jogador responder às 30 perguntas, o referido tema será sinalizado como concluído na área de seleção de temas.
                </li>
                <li>
                  O jogador poderá sair do aplicativo e retornar quando desejar, continuando de onde parou, exceto durante a resposta de uma pergunta.
                </li>
                <li>
                  Antes de responder a uma pergunta o jogador escolhe o nível de dificuldade relacionado ao tempo que terá para responder a próxima pergunta, conforme as opções a seguir:
                  <ul className="lists-ul">
                    <li>120 segundos = 1 ponto cada</li>
                    <li>90 segundos = 2 pontos cada</li>
                    <li>60 segundos = 3 pontos cada.</li>
                  </ul>
                </li>
                <li>
                  Os pontos acumulados no modo single player poderão ser utilizados no modo multiplayer para acionar as opões blackout e tirar 2 alternativas erradas.
                </li>
                <li>
                  A cada 3 questões respondidas erradas, o acesso ao tema correspondente será bloqueado até que o jogador acesse o item Material de Estudo, localizado no topo do game.
                </li>
              </ol>
              <h3>Jogando no modo Multiplayer</h3>
              <ol className="lists-ol">
                <li>
                  No modo multiplayer um jogador poderá desafiar outro que esteja on-line para uma disputa.
                </li>
                <li>
                  A batalha será sobre o tema que o jogador desafiante escolher no menu inicial.
                </li>
                <li>
                  O sistema buscará um jogador que esteja disponível para disputar uma partida.
                </li>
                <li>
                  O jogador desafiado receberá um aviso de desafio. Ele pode aceitar ou não. Em caso positivo, o jogo começa; se ele negar, o sistema escolhe outro jogador on-line aleatoriamente.
                </li>
                <li>Os dois jogadores disputam simultaneamente.</li>
                <li>
                  São 10 perguntas por partida. Quem responder o maior número de perguntas corretamente e em menor tempo ganha a partida.
                </li>
                <li>
                  Em uma partia o jogo conta com dois tipos de ajuda:
                  <ul className="lists-ul">
                    <li>
                      Blackout - ao ser acionada, a tela do adversário fica escura por 2 segundos. É necessário que o jogador tenha, no mínimo, 50 pontos para usar essa opção.
                    </li>
                    <li>
                      Elimine 2 respostas - ao ser acionada, 2 respostas erradas são apagadas das opções. É necessário que o jogador tenha, no mínimo, 50 pontos para usar essa opção.
                    </li>
                  </ul>
                </li>
                <li>
                  Cada pergunta tem o tempo máximo de 60 segundos para resposta.
                </li>
                <li>
                  Cada resposta correta equivale a 1 ponto. No caso de resposta errada, a pontuação da pergunta é igual a zero.
                </li>
                <li>
                  Caso o oponente desista da partida, o jogador vencerá o jogo por W.O – termo usualmente aplicado quando a vitória é dada a um competidor em virtude da desistência do outro.
                </li>
                <li>O vencedor da partida recebe 30 pontos.</li>
                <li>
                  Ao final de cada partida o jogador pode:
                  <ul className="lists-ul">
                    <li>Jogar novamente com o mesmo adversário</li>
                    <li>Jogar com outro adversário</li>
                    <li>Sair do modo multiplayer</li>
                  </ul>
                </li>
              </ol>
              <h3>Menu do Jogo</h3>
              <p>
                Na parte superior da tela, se apresenta o menu do Jogo com os itens:
                <strong>
                 Menu inicial, Ranking, Material de estudo e menu lateral.
                </strong>
              </p>
              <h3>Menu inicial</h3>
              <p>
                Nesse menu é possível escolher o conteúdo do jogo, os temas disponíveis.
              </p>
              <h3>Material de estudo</h3>
              <p>
                Nesta opção do menu, o jogador terá acesso ao portal da UCSebrae com material relacionado aos temas que poderá auxiliar no seu estudo.
              </p>
              <h3>Ranking</h3>
              <p>
                Serão apresentados os rankings para ambos os modos, sendo caracterizados por:
              </p>
              <ul className="lists-ul">
                <li>
                  <strong>Ranking Single Player</strong> - por número de pontos acumulados
                </li>
                <li>
                  <strong>Ranking Multiplayer</strong> - por número de partidas vencidas
                </li>
              </ul>
              <h3>Menu Lateral</h3>
              <p>
                Nesta opção serão apresentadas as demais funcionalidades do Game
                <strong>Perfil, Regras, FAQ, Termo, Sobre e Sair.</strong>
              </p>
              <h3>Perfil</h3>
              <p>
                Nesse menu, o jogador terá acesso a suas estatísticas de acerto dentro dos temas dos conteúdos, acessos rápidos de documentação do jogo e, poderá ainda, surgir perguntas para compor o banco de questões do jogo.
              </p>
              <h3>Regras</h3>
              <p>Apresenta as regras gerais do jogo. Conteúdo deste documento.</p>
              <h3>FAQ</h3>
              <p>Perguntas frequentes sobre instalação e uso do aplicativo.</p>
              <h3>Termo de Aceite</h3>
              <p>
                Condições gerais do game que deve ser aceito pelo jogador antes de utilizar o jogo. Ao final do Termo de Aceite é possível conhecer a data e horário que o jogador fez o aceite do referido termo.
              </p>
              <h3>Sobre</h3>
              <p>
                Exibe informações técnicas sobre o usuário logado. O dispositivo utilizado, características da tela e tipo de conexão com a internet.
              </p>
              <h3>Sair</h3>
              <p>
                Ao acionar essa opção o usuário sairá do aplicativo e necessitará fazer novo login no próximo acesso.
              </p>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
